.group-box{width:14px;height:14px;display:inline-block;margin:2px 10px 0;border-radius:3px}.orange{background-color:#ff7c00}.violet{background-color:#c682e5}.green{background-color:#6bca53}.blue{background-color:#3656ff}
/*# sourceMappingURL=event-cell-viewer.component-Q35I6FA3.css.map */
